// extracted by mini-css-extract-plugin
module.exports = {"time":"Time_time__2xb2Y","timeOutBound":"Time_timeOutBound__147b9","withReadIndicator":"Time_withReadIndicator__12PdH"};